const manageFocusMode = () => {
  const container = document.body;

  const handleKeyDown = (e: KeyboardEvent) => {
    if ([9].includes(e.which) /* TAB_KEY_CODE */) {
      reset();
      start();
    }
  };

  const handleMouseDown = () => {
    reset();
    window.requestAnimationFrame(() => {
      container.classList.add("focus-disabled");
      container.classList.remove("focus-enabled");
    });
    container.addEventListener("keydown", handleKeyDown);
  };

  const reset = () => {
    window.requestAnimationFrame(() => {
      container.classList.remove("focus-disabled");
      container.classList.add("focus-enabled");
    });
    container.removeEventListener("keydown", handleKeyDown);
    container.removeEventListener("mousedown", handleMouseDown);
  };

  const start = () => {
    container.addEventListener("mousedown", handleMouseDown);
  };

  start();
};

export default manageFocusMode;
